import React, { useEffect } from "react";
import { post } from './io';
import { useDispatch } from "react-redux";

const LoadingSpinner = () => {
  const dispatch = useDispatch();
  // useEffect(() => {
  //   post({
  //   });
  // }, []);
  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <div style={styles.spinner}></div>
        <p style={styles.text}>Logging in...</p>
      </div>
    </div>
  );
};

// Inline styles
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  container: {
    textAlign: "center",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ccc",
    borderTop: "6px solid #007BFF",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    margin: "0 auto 15px auto",
  },
  text: {
    fontSize: "18px",
    color: "#333",
  },
};

// Add keyframes for spinning animation
const styleSheet = document.styleSheets[0];
const keyframes =
  `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`;
styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

export default LoadingSpinner;

